import { Avatar } from '@mui/material'
import { AvatarProps } from '../types'
import { Icon } from '@/shared/ui/icon'
import { commonSteamLogoStyles } from '../constants'

export const BasicAvatarSteam = (props: AvatarProps) => {
  const { width = 44, height = 44, borderRadius = '4px', border = 'none' } = props
  return (
    <div style={{ position: 'relative' }}>
      <Avatar
        variant="square"
        sx={{ borderRadius: borderRadius, border: border, width: width, height: height }}
        src={props.src}
      />
      {props.isSteamLogo && (
        <Icon
          view="steamColor"
          style={commonSteamLogoStyles}
        />
      )}
    </div>
  )
}
